<div class="slds-modal__content slds-p-around_medium">
    <ng-content></ng-content>
</div>
